import React from 'react'
import InlineLoader from './InlineLoader/InlineLoader'

let Loader = () => {
  const divStyles = {
    position: 'fixed',
    width: '100%',
    height: '100%'
  }

  const loaderStyles = {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    width: '150px'
  }

  return (
    <div style={divStyles}>
      <InlineLoader style={loaderStyles} />
    </div>
  )
}

export default Loader



// WEBPACK FOOTER //
// ./src/components/Loader.js